const HEX_COLOR = /^[0-9a-fA-F]{6}$/
const DOCUMENT_ID = /^[a-f0-9]{24,40}$/i

const cssColor = (value) => {
  if (!HEX_COLOR.test(value || '')) {
    return null
  }

  return `#${value}`
}

const mixChannel = (hex, offset, weight, target) => {
  const from = parseInt(hex.slice(offset, offset + 2), 16)
  const toward = parseInt(target.slice(offset, offset + 2), 16)

  return Math.round(from * weight + toward * (1 - weight)).toString(16).padStart(2, '0')
}

const mixColors = (hex, weight, target) => {
  return `#${mixChannel(hex, 1, weight, target)}${mixChannel(hex, 3, weight, target)}${mixChannel(hex, 5, weight, target)}`
}

export const shadeColor = (hex) => mixColors(hex, 0.82, '#000000')

export const softenColor = (hex) => mixColors(hex, 0.14, '#ffffff')

export const shouldLoadSignerBrand = (accessCode) => {
  if (!accessCode || DOCUMENT_ID.test(accessCode)) {
    return false
  }

  return true
}

export const signerLogoSrc = (logo, accessCode) => {
  if (!logo || !accessCode) {
    return null
  }

  const separator = logo.includes('?') ? '&' : '?'

  return `${logo}${separator}signer-access-code=${accessCode}`
}

export const brandFromTheme = (theme, accessCode) => {
  const background = cssColor(theme?.primary_color)
  const text = cssColor(theme?.secondary_color)

  if (!background || !text) {
    return null
  }

  return {
    accountName: theme.account_name || '',
    logoSrc: signerLogoSrc(theme.logo, accessCode),
    style: {
      '--signer-button-background': background,
      '--signer-button-background-pressed': shadeColor(background),
      '--signer-button-background-soft': softenColor(background),
      '--signer-button-text': text,
    },
  }
}
